/*******************************************************************************
 * Address Step Actions and Reducer
 */

import {
	ActionMap,
	FormContext_Action_Payload,
} from '@/components/forms/FormContext';
import {
	ReplaceVirtuallyFormState,
	StepMap,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

export const SystemIssuesStepActions = {
	ADD_SYSTEM_ISSUE: 'ADD_SYSTEM_ISSUE',
	REMOVE_SYSTEM_ISSUE: 'REMOVE_SYSTEM_ISSUE',
	UPDATE_OTHER_SYSTEM_ISSUE: 'UPDATE_OTHER_SYSTEM_ISSUE',
} as const;

export type SystemIssuesStepAction = keyof typeof SystemIssuesStepActions;

export interface SystemIssuesStepActionPayload
	extends FormContext_Action_Payload<StepMap> {
	[SystemIssuesStepActions.ADD_SYSTEM_ISSUE]: string;
	[SystemIssuesStepActions.REMOVE_SYSTEM_ISSUE]: string;
	[SystemIssuesStepActions.UPDATE_OTHER_SYSTEM_ISSUE]: string;
}

export type SystemIssuesStepActionMap =
	ActionMap<SystemIssuesStepActionPayload>[keyof ActionMap<SystemIssuesStepActionPayload>];

export const isSystemIssuesStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is SystemIssuesStepActionMap =>
	action.type in SystemIssuesStepActions;

export const systemIssuesStepReducer = (
	state: ReplaceVirtuallyFormState,
	action: SystemIssuesStepActionMap,
): ReplaceVirtuallyFormState => {
	switch (action.type) {
		case SystemIssuesStepActions.ADD_SYSTEM_ISSUE:
			return {
				...state,
				systemIssues: [...state.systemIssues, action.payload],
			};
		case SystemIssuesStepActions.REMOVE_SYSTEM_ISSUE:
			return {
				...state,
				systemIssues: state.systemIssues.filter(
					(issue) => issue !== action.payload,
				),
			};
		case SystemIssuesStepActions.UPDATE_OTHER_SYSTEM_ISSUE:
			return {
				...state,
				systemIssues: state.systemIssues.map((issue) =>
					issue.startsWith('Other:') ? action.payload : issue,
				),
			};
		default:
			return state;
	}
};

export const isValid = (state: ReplaceVirtuallyFormState): boolean => {
	return state.systemIssues.length > 0;
};
